import type { MouseEvent } from 'react'

import type { WithLoadingState } from '@eshop/type'

import css from './index.module.css'

import { Image } from '#/global/component/Image/Image'

export interface ItemProps {
    image?: string
    link: string
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
    title: string
}
export const MenuImage = ({
    image,
    link,
    loadingState,
    onClick,
    title,
}: WithLoadingState<ItemProps>) => {
    const imageResolutionList = [
        { width: 40, height: 40 },
    ]

    if (loadingState) {
        return (
            <a className={css.item}>
                <div className="loading">
                    <Image resolutionList={imageResolutionList} />
                </div>
                <span className={`${css.label} loading`} />
            </a>
        )
    }

    return (
        <a className={css.item} href={link} onClick={onClick}>
            <Image resolutionList={imageResolutionList} src={image} alt={title} />
            <span className={css.label}>{title}</span>
        </a>
    )
}

interface ListProps {
    items: WithLoadingState<ItemProps>[]
}
export const MenuImageList = ({ items }: ListProps) => {
    return (
        <div className={css.list}>
            {items.map((item, index) => (
                <MenuImage key={index} {...item} />
            ))}
        </div>
    )
}
